import _ from 'lodash'

const ErrorSeverity = Object.freeze({
  INFO: 'info',
  WARN: 'warn',
  ERROR: 'error'
})


class ValidationError {
  /* Сообщение об ошибке. loc - JSON pointer или { line, column? } */
  /**
   * Сообщение об ошибке
   *
   * @param {string} message Сообщение
   * @param {ErrorSeverity} severity По умолчанию - error
   * @param {(string|{line: number, column: number})} loc JSONPointer или строка и столбец
   */
  constructor(message, severity, loc) {
    this.message = message
    this.severity = severity || ErrorSeverity.ERROR
    this.loc = loc
    if (!_.isString(loc)) {
      this.line = loc.line
      this.column = loc.column || 0
    }
  }
}

export { ErrorSeverity, ValidationError }
